import { useState } from "react";

const defaultFallbackContainerStyle = {
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
};

const defaultFallbackTextStyle = {
  margin: 0,
};

export default function StoreImageFallback({
  src,
  alt,
  fallbackText,
  imageStyle,
  fallbackContainerStyle,
  fallbackTextStyle,
}) {
  const [hasImageError, setHasImageError] = useState(false);

  if (!src || hasImageError) {
    return (
      <div
        style={{
          ...defaultFallbackContainerStyle,
          ...fallbackContainerStyle,
        }}
      >
        <p
          className="line-clamp-2"
          style={{
            ...defaultFallbackTextStyle,
            ...fallbackTextStyle,
          }}
        >
          {fallbackText || alt}
        </p>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      onError={() => setHasImageError(true)}
      style={imageStyle}
    />
  );
}
